import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/constants';
import { ConfirmationModalService } from 'src/app/providers/services/confirmation-modal.service';
import { LoaderService } from 'src/app/providers/services/loader.service';
import { MissionsService } from 'src/app/providers/services/missions.service';
import { NavigationService } from 'src/app/providers/services/navigation.service';
import { ParticipantsService } from 'src/app/providers/services/participants.service';
import { Mission } from 'src/app/storage/models/mission.model';

@Component({
    selector: 'app-participants-config',
    templateUrl: './participants-config.component.html',
    styleUrls: ['./participants-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ParticipantsConfigComponent implements OnInit, OnDestroy {
  mission: Mission;
  displayModal = false;


  private missionSubscription: Subscription;

  constructor(
    private navigationService: NavigationService,
    private missionsService: MissionsService,
    public participantsService: ParticipantsService,
    private loader: LoaderService,
  ) { }

  ngOnInit(): void {
    this.loader.show();
    this.missionSubscription = this.missionsService.selectedMission$.subscribe(async (mission: Mission) => {
      this.mission = mission;
      try {
        await this.participantsService.findAllByMissionId(mission.missionId);
      } catch (_) { } finally {
        setTimeout(() => this.loader.hide(), 600)
      }
    });
  }

  ngOnDestroy(): void {
    if (this.missionSubscription) { this.missionSubscription.unsubscribe(); }
  }

  async reloadList() {
    await this.participantsService.findAllByMissionId(this.mission.missionId);
  }

  async backToMissionConfig() {
    await this.navigationService.navigateFromHome(CONSTANTS.ROUTES.MISSION_CONFIG);
  }

  openParticipantModal() {
    this.displayModal = true;
  }

  closeParticipantModal() {
    this.displayModal = false;
  }
}
